export interface CsvRow {
  category: string;
  productName: string;
  variantName: string;
  displayImageUrl: string;
  referenceImageUrl: string;
  sku: string;
  vendor: string;
  basePrice: string;
  cost: string;
  active: string;
  notes: string;
  description: string;
}

export const CSV_HEADERS: (keyof CsvRow)[] = [
  "category", "productName", "variantName", "displayImageUrl",
  "referenceImageUrl", "sku", "vendor", "basePrice", "cost",
  "active", "notes", "description",
];

export const CSV_HEADER_LABELS: Record<keyof CsvRow, string> = {
  category: "Category",
  productName: "Product Name",
  variantName: "Variant Name",
  displayImageUrl: "Display Image URL",
  referenceImageUrl: "Reference Image URL",
  sku: "SKU",
  vendor: "Vendor",
  basePrice: "Base Price",
  cost: "Cost",
  active: "Active (true/false)",
  notes: "Notes",
  description: "Description",
};

export type ConflictAction = "add_new" | "overwrite" | "merge" | "skip";

export interface ParsedImportRow {
  rowIndex: number;
  raw: CsvRow;
  valid: boolean;
  errors: string[];
  conflict: {
    type: "sku" | "name" | "fuzzy" | null;
    matchedProductId?: string;
    matchedVariantId?: string;
    matchedLabel?: string;
  };
  action: ConflictAction;
}

export interface ImportBatch {
  id: string;
  timestamp: string;
  uploadedBy: string;
  fileName: string;
  summary: {
    created: number;
    overwritten: number;
    merged: number;
    skipped: number;
    invalid: number;
  };
  /** Snapshot of products before import for rollback */
  snapshotBefore: string; // JSON-stringified CatalogProduct[]
  committed: boolean;
}
